import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createActionsHook, createContainer, createHook, createStateHook, createStore } from 'react-sweet-state';
var initialState = {
  shouldUiModificationsLoad: 'unknown',
  hasFinishedLoading: false,
  adjustmentsAreEnabled: false,
  uiModificationsConsentStatus: {}
};
export var actions = {
  resetAdjustmentContext: function resetAdjustmentContext() {
    return function (_ref) {
      var setState = _ref.setState;
      setState(initialState);
    };
  },
  setShouldUiModificationsLoad: function setShouldUiModificationsLoad(status) {
    return function (_ref2) {
      var setState = _ref2.setState;
      setState({
        shouldUiModificationsLoad: status
      });
    };
  },
  setHasFinishedLoading: function setHasFinishedLoading(hasFinishedLoading) {
    return function (_ref3) {
      var setState = _ref3.setState;
      setState({
        hasFinishedLoading: hasFinishedLoading
      });
    };
  },
  setAdjustmentsAreEnabled: function setAdjustmentsAreEnabled(enabled) {
    return function (_ref4) {
      var setState = _ref4.setState;
      setState({
        adjustmentsAreEnabled: enabled
      });
    };
  },
  setUIModificationsConsentStatus: function setUIModificationsConsentStatus(_ref5) {
    var appId = _ref5.appId,
      status = _ref5.status;
    return function (_ref6) {
      var setState = _ref6.setState,
        getState = _ref6.getState;
      var currentConsentState = getState().uiModificationsConsentStatus;
      setState({
        uiModificationsConsentStatus: _objectSpread(_objectSpread({}, currentConsentState), {}, _defineProperty({}, appId, status))
      });
    };
  }
};
export var store = createStore({
  name: 'issue-adjustments-context',
  initialState: initialState,
  actions: actions
});
export var useAdjustmentsContext = createHook(store);
export var useAdjustmentsEnabled = createStateHook(store, {
  selector: function selector(state) {
    return state.adjustmentsAreEnabled;
  }
});
export var useAdjustmentsContextActions = createActionsHook(store);
export var UiModificationContextContainer = createContainer(store, {
  displayName: 'UiModificationContextContainer'
});